var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c81ba;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,74a45.77,45.77,0,0,1-18.12-3.5,21.58,21.58,0,0,1-3.05-1.6A1.62,1.62,0,0,1,28,67.64a17.17,17.17,0,0,1,0-5.16,6.16,6.16,0,0,1,2.34-3.61,15.53,15.53,0,0,1,6.65-3,52,52,0,0,0,5.2-1.44,2.73,2.73,0,0,0,2.13-2.77,1.11,1.11,0,0,0-.24-.71,16.78,16.78,0,0,1-2.74-6.27,1.62,1.62,0,0,0-.57-1,5.64,5.64,0,0,1-1.93-4.07c0-.48,0-.9.68-.91.43,0,.25-.33.23-.51a23.79,23.79,0,0,1-.29-4.3c.22-2.82,1.28-5.19,3.85-6.61a11.24,11.24,0,0,1,11.09.3,1.49,1.49,0,0,0,.49.24c2.88.33,5,3.15,5.18,6.16.09,1.33,0,2.66,0,4,0,.31-.19.67.38.72.29,0,.26.37.23.6-.18,1.69-.29,3.42-2,4.47-.24.15-.22.38-.27.61a20,20,0,0,1-1.06,4.09,8.58,8.58,0,0,1-1.18,2.11,2,2,0,0,0,.5,3.19,8.57,8.57,0,0,0,2.21,1c2.14.69,4.4.93,6.52,1.69a15.26,15.26,0,0,1,3.31,1.58,6.82,6.82,0,0,1,3.3,5.25A17.52,17.52,0,0,1,72,67.14a2.71,2.71,0,0,1-1.39,2.14,31.27,31.27,0,0,1-8.2,3.23A49.76,49.76,0,0,1,50,74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons04);
export default __webpack_public_path__ + "static/media/Icons-04.b92a6a735d2ba8a7a7f832e6d5041f31.svg";
export { ForwardRef as ReactComponent };